// ROUTE CONST TO PREVENT TYPO
const routeConst = {
  //  ========== CHANNEL ==========
  HOME: 'home',
  ANIMATION: 'animation',
  PR_TEMPLATES: 'premiere-pro-templates',
  AE_TEMPLATES: 'after-effects-templates',
  MOTION_TEMPLATES: 'apple-motion-templates',
  THREE_D: '3d',
  VIDEO: 'video',
  STOCK_IMAGE: 'stock-image',
  SFX: 'sound-effects',
  MUSIC: 'music',
  LOTTIE: 'lottie',
  DAVINCHI_RESOLVE_TEMPLATES: 'davinci-resolve-templates',
  VIEW: 'view',
  AUDIOSEARCH: 'audiosearch',
  VISUALSEARCH: 'visualsearch',
  //  ========== ACCOUNT ==========
  LOGIN: 'login',
  SIGNUP: 'signup',
  ACCOUNT: 'account',
  PURCHASE_HISTORY: 'purchase-history',
  //  ========== FREE ==========
  FREE: 'free', // url
  // PR_TEMPLATES: 'premiere-pro-templates', // SAME AS CHANNEL
  // AE_TEMPLATES: 'after-effects-templates', // SAME AS CHANNEL
  FCPX_TEMPLATES: 'fcpx-motion-templates',
  STOCK_FOOTAGE: 'stock-footage',
  GIFS: 'gifs',
  BG_MUSIC: 'background-music',
  //  ========== DLP, CATEGORY ==========
  DLP: 'dlp',
  CATEGORY: 'category',
  // SFX: 'sound-effects', // SAME AS CHANNEL
  // MUSIC: 'music', // SAME AS CHANNEL
  // THREE_D: '3d', // SAME AS CHA\NNEL
  // VIDEO: 'video', // SAME AS CHANNEL
  // ANIMATION: 'animation',
  PR: 'premiere-pro',
  AE: 'after-effects',
  IMAGE: 'image',
  MOTION: 'apple-motion',
  //  ========== ARTISTS ==========
  ARTISTS: 'contributors',
  ARTIST_STEP: 'artist-step',
  ARTIST_STEPS: 'artist-steps',
};

module.exports = routeConst;
